<template>
    <div>
        <b-row>
            <b-col lg="4">
                <b-list-group>
                    <b-list-group-item><h3>Topics</h3></b-list-group-item>
                    <b-list-group-item>
                        <a data-toggle="tab" href="#help_1" role="tab">What is EVV?</a>
                    </b-list-group-item>
                    <b-list-group-item>
                        Mobile App Training
                    </b-list-group-item>
                    <b-list-group-item class="pl-5">
                        <a data-toggle="tab" href="#help_2" role="tab">How to Check In</a>
                    </b-list-group-item>
                    <b-list-group-item class="pl-5">
                        <a data-toggle="tab" href="#help_3" role="tab">How to Check Out</a>
                    </b-list-group-item>
                    
                    <b-list-group-item>
                        Telephony System Training
                    </b-list-group-item>
                    <b-list-group-item class="pl-5">
                        <a data-toggle="tab" href="#help_4" role="tab">How to Check In</a>
                    </b-list-group-item>
                    <b-list-group-item class="pl-5">
                        <a data-toggle="tab" href="#help_5" role="tab">How to Check Out</a>
                    </b-list-group-item>
                    
                    <b-list-group-item>
                        <a href="/manual-shift">Enter Shift Manually</a>
                    </b-list-group-item>
                    <b-list-group-item>
                        <a data-toggle="tab" href="#help_6" role="tab">Frequently Asked Questions</a>
                    </b-list-group-item>
                    <b-list-group-item>
                        <a href="/contact">Contact Us</a>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col lg="8">
                <b-card>
                    <div class="tab-content">
                        <div class="tab-pane active" id="help_1" role="tabpanel">
                            <h3>What is EVV?</h3>
                        </div>
                        <div class="tab-pane" id="help_2" role="tabpanel">
                            <h3>Mobile App Training: How to Check In</h3>
                        </div>
                        <div class="tab-pane" id="help_3" role="tabpanel">
                            <h3>Mobile App Training: How to Check Out</h3>
                        </div>
                        <div class="tab-pane" id="help_4" role="tabpanel">
                            <h3>Telephony System Training: How to Check In</h3>
                        </div>
                        <div class="tab-pane" id="help_5" role="tabpanel">
                            <h3>Telephony System Training: How to Check Out</h3>
                        </div>
                        <div class="tab-pane" id="help_6" role="tabpanel">
                            <h3>Frequently Asked Questions</h3>

                            <div v-for="question in faq" :key="question.q" class="mt-4 p-2">
                                <h4><i class="fa fa-question-circle"></i> {{ question.q }}</h4>
                                <div class="ml-4" v-html="question.a"></div>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        props: ['topics'],

        data() {
            return {
                faq: [
                    {
                        q: 'What is CareExchange?',
                        a: 'It is an electronic reporting system that enables providers to document the precise time service visits start and end and the services provided during each visit.  CareExchange enables claimants to electronically review service visit information and electronically submit invoices for evaluation for reimbursement by long term care insurance carriers.',
                    },
                    {
                        q: 'What is the cost to use the CareExchange electronic reporting system?',
                        a: 'For a limited time, there is no charge to use the CareExchange electronic reporting system – it is a benefit offered by the claimant’s long term care insurance carrier.',
                    },
                    {
                        q: 'What is required to enroll and use the CareExchange electronic reporting system?',
                        a: 'A computer with an internet connection and an email address are required to enroll.  Either a landline telephone number or a mobile device with an internet connection and GPS location services enabled is required for providers to check-in, check-out, and document services provided during the service visit.',
                    },
                    {
                        q: 'How will claimants and providers be trained to use the CareExchange electronic reporting system?',
                        a: 'Training is available online.  Go to <a href="https://www.careexchange.com/help"></a>www.CareExchange.com/Help to access training material.',
                    },
                    {
                        q: 'What is required to receive reimbursement for services provided?',
                        a: 'CareExchange eliminates the need for claimants and providers to maintain paper documentation and submit that documentation for evaluation for reimbursement.  Once enrolled, claimants and providers will no longer use paper timesheets.',
                    },
                    {
                        q: 'How is HIPAA information protected?',
                        a: 'All data is encrypted during transit and at rest.',
                    },
                    {
                        q: 'How will emergency, back-up, or respite care from an interim provider be documented?',
                        a: 'If a situation arises and emergency, back-up, or respite care by a different provider is required, the paper process should be followed.  Interim providers will use paper timesheets and claimants will submit the paper timesheets for the interim provider according to the paper submission process.  Further information is available online.  Go to www.CareExchange.com/Help to access instructions and to download and print forms.',
                    },
                    {
                        q: 'May providers document the services provided at a later time, after the visit is completed?',
                        a: 'No, providers must document the services provided at the end of each visit, during the check-out process.',
                    },
                ],
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/variable';

    .training-hq {
        border-left: solid 1px $dark;
    }

    .training-nav {
        height: 100%;

        .nav {
            .nav-item {
                .nav-link {
                    color: $primary;
                }
            }
        }
    }
</style>